const ServiceURL = "https://www.24qr.de/services/index.php/";
export default ServiceURL;